import "./reviews.scss";
import { Link } from "react-router-dom";

// Reviews section (backlog #8, 2026-10-26): homepage visitors had no
// social proof before booking — the only reviews lived as screenshots
// on the separate /reviews page, which most visitors never reach.
// The three quotes below are copied verbatim from those Google review
// screenshots already published on /reviews (reviews1.png /
// reviews2.png). Only reviews whose full text is visible in the
// screenshots are used; reviews cut off with "... More" in the
// screenshots were left out rather than completed or paraphrased.
// All three are 5-star Google reviews, shown with the reviewer's name
// exactly as it appears in the screenshots. The Basking Ridge rating
// line was cross-checked 2026-10-26 via Places search + details:
// 5.0 average from 9 Google reviews. No other rating, count, or
// testimonial is claimed. Price, payment link, phone, and addresses
// are unchanged.
const REVIEWS = [
  {
    name: "Claire Park",
    text: "SKY Taekwondo is a wonderful place to learn TKD. Master Park is an amazing instructor. You can really learn a lot from him and he cares a lot about his students. There's a very friendly and welcoming atmosphere and is a great place for both the beginners and the experienced.",
  },
  {
    name: "Mackenzie Lawlor",
    text: "SKY Taekwondo is a great school for all, from beginners to black belts. Master Park and Master Kim are excellent and patient teachers, and my classes with them have always been rewarding and instructive. I feel that they have greatly enriched my Taekwondo experience.",
  },
  {
    name: "Anish Parikh",
    text: "The lessons are a great way to exercise and learn about self-defense and life lessons. I have been going to SKY taekwondo for a long time and my experiences and growth here have been amazing.",
  },
];

export default function Reviews() {
  return (
    <section className="section reviews-section" id="reviews-home">
      <div className="container reviews-container">
        <p className="reviews-eyebrow">GOOGLE REVIEWS</p>
        <h2 className="reviews-title">What Students Say</h2>
        <p className="reviews-lead">
          Real reviews from our Google listings — Basking Ridge is rated
          5.0 stars from 9 Google reviews.
        </p>

        <div className="grid reviews-grid">
          {REVIEWS.map((review) => (
            <figure className="reviews-card" key={review.name}>
              <div className="reviews-stars" aria-label="5 out of 5 stars">
                ★★★★★
              </div>
              <blockquote className="reviews-quote">
                &ldquo;{review.text}&rdquo;
              </blockquote>
              <figcaption className="reviews-author">
                — {review.name}, Google review
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="reviews-more">
          <Link to="/reviews">Read more reviews</Link>
        </p>

        <p className="reviews-cta-row">
          <Link to="/#trial" className="reviews-cta">
            Try It Yourself — Book My FREE Class
          </Link>
        </p>
        <p className="reviews-alt">
          Questions? <a href="mailto:pskyman1@gmail.com">Email us at pskyman1@gmail.com</a>
        </p>
      </div>
    </section>
  );
}
